import React from 'react';
import { ScrollMenu } from 'react-horizontal-scrolling-menu';

import { LeftArrow, RightArrow } from './Arrows';
import { Card } from './Card';

interface Props<T> {
  items?: T[];
  hideArrows?: boolean;
}

function HorizontalScroll<T>({ items, hideArrows = false }: Props<T>) {
  return (
    <ScrollMenu
      LeftArrow={hideArrows ? <div /> : LeftArrow}
      RightArrow={hideArrows ? <div /> : RightArrow}
      key={Date.now()}
    >
      {items.map((item, idx) => (
        <Card key={idx} product={item} />
      ))}
    </ScrollMenu>
  );
}

export default HorizontalScroll;
